import { __awaiter, __generator } from "tslib";
import { showTaskModule } from './TaskModuleFunctions';
import { createHeaderlessDialogInfo } from './utilities/createHeaderlessDialogInfo';
import { getStoreDialogProps } from './utilities/getStoreDialogProps';
/**
 * Generic function called to display URL content in a dialog
 * @param appId Id of the app
 * @param title Title of dialog and aria-label read by narrator
 * @param contentUrl URL string whose content will be loaded in the dialog
 * @returns Promise<((err: string, result: string) => void) | undefined>
 */
export var showStoreAppDialog = function (_appId, title, contentUrl, dialogType) { return __awaiter(void 0, void 0, void 0, function () {
    var taskModuleProps;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getStoreDialogProps(createHeaderlessDialogInfo(contentUrl, title), dialogType)];
            case 1:
                taskModuleProps = _a.sent();
                if (taskModuleProps) {
                    return [2 /*return*/, showTaskModule(taskModuleProps)];
                }
                return [2 /*return*/, undefined];
        }
    });
}); };
//# sourceMappingURL=showStoreAppDialog.js.map